import { isWebView } from "./deviceUtils";
import { idbItems } from "./indexedDB";
import { BridgeParameter } from "../types/bridgeParameter";
import { idbHelper } from "../utils/idbHelper";

export const sendOnExecuteCallback = async (key: string, param: any) => {
    const parameter: BridgeParameter = {
        type: key,
        param: param,
    };
    
    try {
        const stringifiedObject = JSON.stringify(parameter);
        //console.log(stringifiedObject);

        (window as any).onExecuteCallback(stringifiedObject);        
    } catch (error) {
        console.error('Error calling sendOnExecuteCallback:', error);
    }

}

export const simulateNativeIF = async (key: string, param: any): Promise<boolean> => {
    try {
        if (process.env.REACT_APP_ENV_MODE === 'local' && !isWebView()) {
            switch (key) {
                case 'INITIAL_LOADING_FINISHED':
                    //await idbItems.del('termsHideDuration'); // test
                    //await idbItems.del('agreementList'); // test

                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'DEVICE_SYSTEM_INFO':
                    /*
                        .env.local 파일에 아래와 같이 설정 
                        예)
                        REACT_APP_DS_APP_VER='04.00.04'
                        REACT_APP_DS_OS='IOS'
                        REACT_APP_DS_OS_VER='16.7.11'
                        REACT_APP_DS_MODEL='iPhone10,6'
                    */
                    const ctn = await idbItems.get('ctn') ?? process.env.REACT_APP_DS_CTN;
                    const first_loading = await idbItems.get('first_loading') ?? process.env.REACT_APP_DS_FIRST_LOADING;
                    param = {
                        version_info: process.env.REACT_APP_DS_APP_VER ?? '',
                        os_info: process.env.REACT_APP_DS_OS ?? '',
                        os_version: process.env.REACT_APP_DS_OS_VER ?? '',
                        dev_model: process.env.REACT_APP_DS_MODEL ?? '',
                        tel_info: process.env.REACT_APP_DS_TEL_INFO ?? '',
                        ctn_info: ctn ?? '00000000000',
                        first_loading: first_loading ?? true,
                    };
                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'GET_MEMBER_ID':
                    const memberId = await idbItems.get('memberId');
                    param = {
                        memberId: memberId || ''
                    }
                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'GET_AD_AGREE':
                    const adAgreeYn = await idbHelper.getAdAgreeYn();
                    param = {
                        agree: adAgreeYn === 'Y' ? true : false
                    }
                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'WAITING_LINE_POPUP':
                    param.result = '00';
                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'FCM_TOKEN':
                    param = {
                        fcmToken: ''
                    }
                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'RESET_LOGIN_INFO':
                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'SET_PASSWORD':
                    param = {
                        ...param,
                        result: '00',
                        password: process.env.REACT_APP_P_W || ''
                    }
                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'CHECK_PASSWORD':
                    param = {
                        ...param,
                        result: '00',
                        password: process.env.REACT_APP_P_W || ''
                    }
                    await sendOnExecuteCallback(key, param);
                    return true;
                case 'PASSWORD':
                    param = {
                        ...param,
                        password: process.env.REACT_APP_P_W || ''
                    }
                    await sendOnExecuteCallback(key, param);
                    return true;
                default:
                    break;
            }
        }
    } catch (error) {
        console.error('Error calling simulateNativeIF:', error);
    }

    return false;
};
